import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SimpleViewCommissioningComponent } from './simple-view-commissioning.component';

const routes: Routes = [
  { path: '', component:  SimpleViewCommissioningComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SimpleViewCommissioningRoutingModule { }
